
export const APP_INITED = 'APP_INITED';
